"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
exports.__esModule = true;
exports.modifyRelationship = exports.removeRelationship = exports.addRelationship = void 0;
var lodash_1 = require("lodash");
exports.addRelationship = function (relationship, value, onChange) {
    var copyRelationship = lodash_1.clone(relationship);
    var relationshipAlreadySelected = value.filter(function (t) { return t.id === relationship.id; });
    if (relationshipAlreadySelected.length) {
        return;
    }
    onChange(__spreadArrays(value, [copyRelationship]));
};
exports.removeRelationship = function (index, value, onChange) {
    var newRelationships = value.slice();
    newRelationships.splice(index, 1);
    onChange(newRelationships);
};
exports.modifyRelationship = function (index, modifiedRelationship, value, onChange) {
    var newRelationships = value.slice();
    newRelationships[index] = modifiedRelationship;
    onChange(newRelationships);
};
